import type { MerchantPatternDTO } from '@eriko/shared-types';
import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export async function listRules(): Promise<MerchantPatternDTO[]> {
  const res = await apiClient.get<MerchantPatternDTO[]>(ENDPOINTS.rules.list);
  return res.data;
}

export async function createRule(body: {
  pattern: string;
  categorySlug: string;
}): Promise<MerchantPatternDTO> {
  const res = await apiClient.post<MerchantPatternDTO>(ENDPOINTS.rules.list, body);
  return res.data;
}

export async function updateRule(
  id: string,
  body: { pattern?: string; categorySlug?: string },
): Promise<MerchantPatternDTO> {
  const res = await apiClient.patch<MerchantPatternDTO>(ENDPOINTS.rules.detail(id), body);
  return res.data;
}

export async function deleteRule(id: string): Promise<{ id: string }> {
  const res = await apiClient.delete<{ id: string }>(ENDPOINTS.rules.detail(id));
  return res.data;
}
